export default "__VITE_ASSET__6a5755c7__"